// @flow strict

// eslint-disable-next-line
export { default as Sticky } from './Sticky';
